module.exports = __webpack_public_path__ + "static/media/img_keyong@2x.5bf977bf.png";